import { useCallback, useState, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useMsal } from '@azure/msal-react'
import Swal from 'sweetalert2'

import Footer from './Footer'
import HeaderDesktop from './HeaderDesktop'
import useRefreshToken from '../hooks/useRefreshToken'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import useLogout from '../hooks/useLogout'
import {
	setNavigation,
	setIsAllowAdmin,
	setDefaultWorkstream
} from '../slices/navigationSlice'
import Loading from './Loading'
import useSilentLogin from '../hooks/useSilentLogin'
import { initialMylist } from '../slices/mylistSlice'
import { setNotifications } from '../slices/notificationSlice'
import { callMsGraph, loginRequest } from '../config/msalConfig'

const Layout = () => {
	const [loading, setLoading] = useState(true)
	const refresh = useRefreshToken()
	const axiosPrivate = useAxiosPrivate()
	const logout = useLogout()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { accounts, instance } = useMsal()
	const { handleSilentLogin } = useSilentLogin()

	const initLayout = useCallback(async () => {
		try {
			await refresh()
		} catch (err) {
			Swal.fire({
				title: 'Error!',
				text: 'Access token is expired, try logging in again',
				icon: 'error',
				confirmButtonText: 'Ok'
			}).then(() => logout())
		}

		try {
			const { data } = await axiosPrivate.get('/POP_Homepage/Get_MenuFrontEnd_List')
			const { data: notifications } = await axiosPrivate.get(
				'/POP_Homepage/GetNotiList'
			)

			dispatch(setNavigation(data.tb_menu_list_homepage))
			dispatch(setIsAllowAdmin(data.tb_allow_admin_page[0].isAllowAdminPage))
			dispatch(setDefaultWorkstream(data.tb_allow_admin_page[0].defaultWorkStream))
			dispatch(initialMylist(data))
			dispatch(setNotifications(notifications.noti_List))
		} catch (err) {
			//
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (accounts.length > 0) {
			instance
				.acquireTokenSilent({
					...loginRequest,
					account: accounts[0]
				})
				.then(response => {
					callMsGraph(response.accessToken).then(response => {
						handleSilentLogin({
							...accounts[0],
							email: response.mail
						}).then(resp => {
							if (resp.allowRegister) {
								navigate('/register', {
									replace: true,
									state: {
										...accounts[0],
										comID: resp.comID,
										email: response.mail
									}
								})
							}

							if (!resp.allowRegister && !resp.isAllowToSystem) {
								navigate('/login', { replace: true })
							}

							if (resp.isAllowToSystem) {
								initLayout().then(() => setLoading(false))
							}
						})
					})
				})

			// handleSilentLogin(accounts[0]).then(resp => {
			// 	if (resp.allowRegister) {
			// 		navigate('/register', { replace: true, state: accounts[0] })
			// 	}

			// 	if (!resp.allowRegister && !resp.isAllowToSystem) {
			// 		navigate('/login', { replace: true })
			// 	}

			// 	if (resp.isAllowToSystem) {
			// 		initLayout().then(() => setLoading(false))
			// 	}
			// })
		} else if (sessionStorage.getItem('fakeLogin')) {
			initLayout().then(() => setLoading(false))
		} else {
			navigate('/login', { replace: true })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (loading) return <Loading />

	return (
		<main className="wrapper">
			{/* <HeaderMobile /> */}
			<HeaderDesktop />

			<Outlet />

			<Footer />
		</main>
	)
}

export default Layout
